<template>
  <div class="AiTestimonial" :class="{ 'AiTestimonial--current': current }">
    <ai-typo
      aria-hidden="true"
      class="AiTestimonial-title"
      as="span"
      variant="overline-01"
      color="gold-900">
      {{ $t('ux.organisms.testimonials.title') }}
    </ai-typo>
    <figure>
      <ai-typo
        role="blockquote"
        class="AiTestimonial-description"
        as="blockquote"
        variant="heading-03">
        {{ reviewText }}
      </ai-typo>
      <figcaption>
        <ai-typo
          class="AiTestimonial-author"
          as="span"
          variant="paragraph-04-bold">
          {{ author }}
        </ai-typo>
        <ai-typo as="cite" variant="paragraph-04-regular">
          {{
            $t('ux.organisms.testimonials.location', {
              hotelName: hotelName,
              country: country,
            })
          }}
        </ai-typo>
      </figcaption>
    </figure>
  </div>
</template>

<script setup lang="ts">
export interface Props {
  reviewText: string;
  author: string;
  hotelName?: string;
  country?: string;
  current: boolean;
}
defineProps<Props>();
</script>
<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/mixins';
.AiTestimonial {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: constants.$padding-03 constants.$padding-02;

  @media (mq.$from-medium) {
    background-size: contain;
    background-position: calc(50% + constants.$margin-07) 50%;
    padding: constants.$padding-08 constants.$padding-10 constants.$padding-04;
  }
}

.AiTestimonial-title {
  text-transform: uppercase;
  margin-bottom: constants.$margin-05;
}

.AiTestimonial-description {
  margin-inline: 0;
  margin-bottom: constants.$margin-02;
  margin-top: 0;
  padding: 0;
}

.AiTestimonial-author {
  display: block;
  margin-bottom: constants.$inner-01;
}
</style>
